import axios from "axios";
import { api_url } from "../config/config";

const BASE = `${api_url}financement/fournisseurs`;

export const fournisseurService = {
  getAllFournisseurs: () => {
    return axios.get(BASE);
  },
  getFournisseur: (uuid) => {
    return axios.get(`${BASE}/${uuid}`);
  },
  createFournisseur: (data) => {
    return axios.post(BASE, data);
  },
  updateFournisseur: (uuid, data) => {
    return axios.put(`${BASE}/${uuid}`, data);
  },
  deleteFournisseur: (uuid) => {
    return axios.delete(`${BASE}/${uuid}`);
  },
};
